const AmazonIcon = () => {
  return (
    <svg
      width="200"
      height="36"
      viewBox="0 0 761 136"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M645.817 68C645.817 76.0702 639.317 84.4098 625.881 92.4664C612.591 100.435 593.206 107.693 569.045 113.82C520.761 126.066 453.931 133.665 380.025 133.665C306.12 133.665 239.29 126.066 191.005 113.82C166.845 107.693 147.459 100.435 134.17 92.4664C120.734 84.4098 114.233 76.0702 114.233 68C114.233 59.9298 120.734 51.5902 134.17 43.5336C147.459 35.5652 166.845 28.3071 191.005 22.1798C239.29 9.9342 306.12 2.33467 380.025 2.33467C453.931 2.33467 520.761 9.9342 569.045 22.1798C593.206 28.3071 612.591 35.5652 625.881 43.5336C639.317 51.5902 645.817 59.9298 645.817 68Z"
        stroke="#EB9CDE"
        strokeWidth="4.66935"
      />
      <g filter="url(#filter0_i_2038_2393)">
        <path
          d="M0 85.2419L22.8439 50.6755H42.8824L65.6761 85.2419H43.2831L41.5798 82.0858H22.6936L20.9402 85.2419H0ZM32.2119 64.8527L28.2543 72.0666H36.1194L32.2119 64.8527Z"
          fill="white"
        />
        <path
          d="M106.081 81.7852L90.3008 71.1147V85.2419H70.5629V50.6755H86.1428L106.231 64.8527L126.17 50.6755H141.599V85.2419H121.811V71.1147L106.081 81.7852Z"
          fill="white"
        />
        <path
          d="M201.6 73.8199V85.2419H149.049V75.6735L171.592 62.0974H149.901V50.6755H200.849V60.3441L179.007 73.8199H201.6Z"
          fill="white"
        />
        <path
          d="M277.489 75.3228V85.2419H228.344V50.6755H277.489V60.5945H248.082V64.502H277.489V71.4153H248.082V75.3228H277.489Z"
          fill="white"
        />
        <path
          d="M285.569 85.2419V50.6755H316.98C320.754 50.6755 323.926 50.8091 326.498 51.0763C329.103 51.3434 331.508 51.8444 333.712 52.5791C335.916 53.3139 337.653 54.3325 338.922 55.635C340.191 56.9375 341.16 58.6074 341.828 60.6446C342.529 62.6485 342.88 65.1032 342.88 68.0088C342.88 71.3819 342.412 74.1706 341.477 76.3748C340.542 78.5791 338.989 80.3491 336.818 81.685C334.647 82.9875 331.992 83.906 328.853 84.4403C325.713 84.9747 321.756 85.2419 316.98 85.2419H285.569ZM312.571 74.3209C316.846 74.3209 319.652 73.9368 320.988 73.1687C322.357 72.4005 323.041 70.6806 323.041 68.0088C323.041 66.7731 322.925 65.7878 322.691 65.0531C322.457 64.285 322.14 63.6671 321.739 63.1995C321.338 62.6986 320.67 62.3479 319.735 62.1475C318.8 61.9137 317.831 61.7634 316.83 61.6966C315.828 61.6299 314.408 61.5965 312.571 61.5965H305.307V74.3209H312.571Z"
          fill="white"
        />
        <path
          d="M349.477 69.712V50.6755H369.215V66.7063C369.215 69.3113 369.916 71.1147 371.319 72.1167C372.722 73.0852 374.976 73.5694 378.082 73.5694C381.188 73.5694 383.442 73.0852 384.845 72.1167C386.248 71.1147 386.949 69.3113 386.949 66.7063V50.6755H406.687V69.712C406.687 75.3896 404.516 79.5309 400.174 82.1359C395.833 84.7075 388.469 85.9933 378.082 85.9933C367.695 85.9933 360.331 84.7075 355.989 82.1359C351.648 79.5643 349.477 75.423 349.477 69.712Z"
          fill="white"
        />
        <path
          d="M455.538 69.6619H475.125C474.925 71.432 474.658 72.9349 474.324 74.1706C474.023 75.4063 473.572 76.642 472.971 77.8777C472.37 79.08 471.585 80.082 470.617 80.8835C469.648 81.685 468.412 82.4365 466.909 83.1378C465.44 83.8392 463.653 84.3902 461.549 84.791C459.479 85.1584 457.024 85.4422 454.185 85.6426C451.38 85.8764 448.14 85.9933 444.466 85.9933C438.421 85.9933 433.479 85.7261 429.638 85.1918C425.797 84.624 422.624 83.6388 420.12 82.2361C417.615 80.8334 415.845 79.0132 414.809 76.7756C413.808 74.5046 413.307 71.5823 413.307 68.0088C413.307 65.0698 413.657 62.5817 414.359 60.5444C415.093 58.5072 416.179 56.7872 417.615 55.3845C419.084 53.9818 421.088 52.8964 423.626 52.1283C426.198 51.3267 429.12 50.759 432.393 50.425C435.7 50.091 439.724 49.924 444.466 49.924C450.411 49.924 455.27 50.1912 459.044 50.7256C462.818 51.2599 465.807 52.1784 468.012 53.4809C470.249 54.7834 471.836 56.3197 472.771 58.0897C473.739 59.8598 474.407 62.1976 474.775 65.1032H455.287C455.087 63.6003 454.235 62.5984 452.732 62.0974C451.229 61.5965 448.474 61.346 444.466 61.346C439.824 61.346 436.752 61.7467 435.249 62.5483C433.779 63.3164 433.044 65.1366 433.044 68.0088C433.044 70.7808 433.796 72.5675 435.299 73.3691C436.802 74.1706 439.858 74.5714 444.466 74.5714C448.541 74.5714 451.363 74.2541 452.933 73.6195C454.536 72.985 455.404 71.6658 455.538 69.6619Z"
          fill="white"
        />
        <path
          d="M476.245 85.2419L499.088 50.6755H519.127L541.921 85.2419H519.528L517.824 82.0858H498.938L497.185 85.2419H476.245ZM508.456 64.8527L504.499 72.0666H512.364L508.456 64.8527Z"
          fill="white"
        />
        <path
          d="M596.673 50.6755V64.502H577.837V85.2419H558.099V64.502H539.263V50.6755H596.673Z"
          fill="white"
        />
        <path
          d="M622.356 50.6755V85.2419H602.568V50.6755H622.356Z"
          fill="white"
        />
        <path
          d="M675.314 85.4422C671.807 85.8096 667.482 85.9933 662.339 85.9933C657.195 85.9933 652.854 85.8096 649.314 85.4422C645.807 85.0749 642.751 84.4904 640.146 83.6889C637.574 82.8873 635.571 81.7852 634.135 80.3825C632.698 78.9464 631.646 77.2432 630.978 75.2727C630.311 73.3023 629.977 70.881 629.977 68.0088C629.977 65.0698 630.344 62.5817 631.079 60.5444C631.813 58.5072 632.932 56.7872 634.435 55.3845C635.938 53.9818 638.009 52.8964 640.647 52.1283C643.285 51.3267 646.308 50.759 649.714 50.425C653.154 50.091 657.362 49.924 662.339 49.924C667.315 49.924 671.506 50.091 674.913 50.425C678.353 50.759 681.392 51.3267 684.03 52.1283C686.702 52.8964 688.773 53.9818 690.242 55.3845C691.745 56.7872 692.864 58.5072 693.599 60.5444C694.333 62.5817 694.701 65.0698 694.701 68.0088C694.701 70.881 694.367 73.3023 693.699 75.2727C693.031 77.2432 691.979 78.9464 690.543 80.3825C689.107 81.7852 687.086 82.8873 684.481 83.6889C681.91 84.4904 678.854 85.0749 675.314 85.4422ZM654.073 73.6195C655.776 73.9201 658.531 74.0704 662.339 74.0704C666.146 74.0704 668.885 73.9201 670.555 73.6195C672.258 73.319 673.41 72.7679 674.011 71.9664C674.646 71.1648 674.963 69.8456 674.963 68.0088C674.963 66.8399 674.863 65.9214 674.662 65.2535C674.462 64.5855 674.145 64.0011 673.711 63.5001C673.276 62.9991 672.525 62.6485 671.456 62.4481C670.421 62.2143 669.235 62.064 667.899 61.9972C666.563 61.897 664.71 61.8469 662.339 61.8469C659.968 61.8469 658.114 61.897 656.778 61.9972C655.442 62.064 654.24 62.2143 653.171 62.4481C652.136 62.6485 651.401 62.9991 650.967 63.5001C650.533 64.0011 650.215 64.5855 650.015 65.2535C649.815 65.9214 649.714 66.8399 649.714 68.0088C649.714 69.8456 650.015 71.1648 650.616 71.9664C651.251 72.7679 652.403 73.319 654.073 73.6195Z"
          fill="white"
        />
        <path
          d="M702.143 50.6755H717.923L741.919 66.4057V50.6755H760.405V85.2419H744.975L720.628 70.0126V85.2419H702.143V50.6755Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_2038_2393"
          x="0"
          y="49.924"
          width="760.405"
          height="39.5123"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.44304" />
          <feGaussianBlur stdDeviation="1.72152" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2038_2393"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AmazonIcon;
